import { Link } from 'react-router-dom';

import { useSelector, useDispatch } from 'react-redux';
import { RootState } from '../../store/store';
import { logoutUser } from '../../features/user/userSlice';

import { Col, Row, Flex } from 'antd';
import { LogoutOutlined, UserOutlined } from '@ant-design/icons';

import logo from '../../assets/images/logo.png';

const NavBar: React.FC = () => {
  const { loggedIn, user, rol } = useSelector((state: RootState) => state.user);
  const dispatch = useDispatch();
  const isAdmin = rol === 'Administrador' || rol === 'Empresa' || user?.is_staff;
  return loggedIn ? (
    <Row className='navbar'>
      <Col span={4} className='logo-menu-container'>
        <img src={logo} alt='logo' className='logo-menu' />
      </Col>
      <Col span={20}>
        <Flex justify={'flex-end'} align={'center'} className='menu-container' component={'ul'}>
          <li className='menu-item' title='Lista de Proyectos'>
            <Link to='/proyectos'>Proyectos</Link>
          </li>

          {isAdmin ? (
            <li className='menu-item'>
              <Link to='/usuarios'>Usuarios</Link>
            </li>
          ) : null}

          <li className='menu-item'>
            <Link to='/perfil' title='Perfil'>
              <UserOutlined /> {user.username}{' '}
            </Link>
          </li>
          <li className='menu-item' onClick={() => dispatch(logoutUser())}>
            <LogoutOutlined title='Cerrar Sesión' />
          </li>
        </Flex>
      </Col>
    </Row>
  ) : null;
};

export default NavBar;
